import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  Input,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../components/TextField';
import {Colxx, Separator} from '../../../components/common/CustomBootstrap';
import LoaderButton from '../../../components/LoaderButton';
import Breadcrumb from '../../../containers/navs/Breadcrumb';
import FieldError from "../../../components/FieldError";
import Select from "react-select";
import {store} from "../../../AppRenderer";
import {
  composeValidators,
  length,
  mustBeInteger,
  mustBeNumber,
  mustBePositive,
  required
} from "../../../helpers/Validators";
import {getDatePickerProps, numberWithCommas, stringToNumber} from "../../../helpers/Utils";
import {NotificationManager} from "../../../components/common/react-notifications";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import ModalManager from "../../../components/modal/ModalManager";
import fa_IR from "../../../constants/locales";
import i18n from "../../../services/i18n";
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import Api from "../../../services/Api";
import moment from "moment";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destInputValue: '',
      giftCardSettings: null,
    };

    this.tokenOptions = store.getState().general.tokens.map(token => ({
      label: token.localeName, value: token.symbol
    }));
  }

  createGiftCard = async values => {
    const {t} = this.props;
    const {name, code, recipientType, recipient, count, tokens, expiresAt} = values;
    try {
      await Api.invoke('POST', '/v2/admin-ui/giftCards', {
        name,
        status: "STARTED",
        recipient: {
          type: recipientType.value,
          value: recipientType.value === "GROUP" ? recipient.value : recipient,
        },
        gifts: tokens.map(item => ({
          token: item.value,
          amount: Number(values[`${item.value}Amount`]),
        })),
        ...(code ? {code} : null),
        ...(expiresAt || recipientType.value === "GROUP" ? {
          expireCriteria: {
            ...(expiresAt ? {time: moment(expiresAt).toISOString()} : null),
            ...(recipientType.value === "GROUP" ? {numUsage: Number(count)} : null),
          },
        } : null),
      });
      NotificationManager.success(t('Gift card created successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  MultiSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  SelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  openConfirmDialog = onConfirm => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Submit Confirm'),
      body: t('Are you sure you want to create this gift card ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            onConfirm();
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  render() {
    const {t, match, history} = this.props;
    const {app} = store.getState();
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Create Gift Card')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.createGiftCard}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors, values}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row className="mb-2">
                          <Col className="col-lg-5 col-md-12">
                            <TextField
                              item={{
                                name: 'name',
                                i18n: t('Name'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col className="col-lg-5 col-md-12">
                            <TextField
                              item={{
                                name: 'code',
                                i18n: t('Code'),
                                type: 'text',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Recipient Type')}<span className="required">*</span></span>
                            <Field
                              name="recipientType"
                              options={[
                                {label: 'GROUP', value: 'GROUP'},
                                {label: 'USER', value: 'USER'},
                                {label: 'PHONE_NUMBER', value: 'PHONE_NUMBER'},
                              ]}
                              component={this.SelectAdapter}
                            />
                            <FieldError name='recipientType'/>
                          </Col>
                        </Row>
                        {!!values.recipientType && values.recipientType.value === "GROUP" &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('User Groups')}<span className="required">*</span></span>
                              <Field
                                name="recipient"
                                options={[
                                  {label: 'ALL_USERS', value: ''},
                                ]}
                                component={this.SelectAdapter}
                              />
                              <FieldError name='recipientType'/>
                            </Col>
                          </Row>
                        }
                        {!!values.recipientType && values.recipientType.value === "USER" &&
                          <Row className="mb-2">
                            <Col className="col-lg-5 col-md-12">
                              <TextField
                                item={{
                                  name: 'recipient',
                                  i18n: t('User Id'),
                                  type: 'text',
                                  required: true,
                                }}
                              />
                            </Col>
                          </Row>
                        }
                        {!!values.recipientType && values.recipientType.value === "PHONE_NUMBER" &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="recipient" validate={composeValidators(required, mustBeNumber, length(11))}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Mobile Number')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      onChange={e => {input.onChange(e.target.value);}}
                                    />
                                    <FieldError name="recipient"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.recipientType && values.recipientType.value === "GROUP" &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="count" validate={composeValidators(required, mustBeNumber, mustBeInteger, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Count')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="count"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Token')}<span className="required">*</span></span>
                            <Field
                              name="tokens"
                              component={this.MultiSelectAdapter}
                              options={this.tokenOptions}
                            />
                            <FieldError name='token'/>
                          </Col>
                        </Row>
                        {!!values.tokens && values.tokens.map(item => (
                          <Row className="mb-3" key={item.value}>
                            <Col className="col-lg-5 col-md-12">
                              <Field name={`${item.value}Amount`} validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t("Amount")} {item.value}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name={`${item.value}Amount`}/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        ))}
                        <Row className="mb-4">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Expiration Date')}<span className="required">*</span></span>
                            <Field name="expiresAt" validate={required}>
                              {({input}) => (
                                <MuiPickersUtilsProvider
                                  utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                                  locale={i18n.language}
                                >
                                  <DateTimePicker
                                    {...getDatePickerProps()}
                                    minDate={moment()}
                                    maxDate={undefined}
                                    value={input.value ? input.value : null}
                                    onChange={date => {
                                      if (moment(date) >= moment()) {
                                        input.onChange(date);
                                      } else {
                                        alert(t("The selected time must be ahead of the current time."));
                                      }
                                    }}
                                    TextFieldComponent={props =>
                                      <Input
                                        style={{width: '100%'}}
                                        placeholder={t('Select')}
                                        {...props}
                                      />
                                    }
                                  />
                                </MuiPickersUtilsProvider>
                              )}
                            </Field>
                          </Col>
                        </Row>
                        {!!app.giftCardSettings &&
                          <Row className="mb-2">
                            <Col className="col-lg-5 col-md-12">
                              <div
                                onClick={() => {history.push("/dashboard/users/" + app.giftCardSettings.exchangeCreditor.id);}}
                                className="d-flex flex-row align-items-center justify-content-between p-3 cursor-pointer"
                                style={{border: "1px solid #d7d7d7", borderRadius: 8, background: "#E9ECEF"}}>
                                <div>{t('Creditor')}</div>
                                <div>{
                                  app.giftCardSettings.exchangeCreditor.email ||
                                  app.giftCardSettings.exchangeCreditor.phoneNumber
                                }</div>
                              </div>
                            </Col>
                          </Row>
                        }
                        <LoaderButton
                          loading={submitting}
                          onClick={() => {
                            this.openConfirmDialog(
                              handleSubmit,
                            );
                          }}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Submit')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
